import { render, staticRenderFns } from "./EnterArticleAttribute.vue?vue&type=template&id=eae2609a"
import script from "./EnterArticleAttribute.vue?vue&type=script&lang=js"
export * from "./EnterArticleAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports